import { consultInterface } from "api-interface/consult.interface";



export class ConsultantModel implements consultInterface.consultant.GetRes  {

        /** 1.身体的な攻撃 */
        physicalBattering: string;
        /** 2.精神的な攻撃 */
        psychologicalBattering: string;
        /** 3.人間関係からの切り離し */
        ostracized: string;
        /** 4.過大な要求 */
        excessiveRequest: string;
        /** 5.過小な要求 */
        underrated: string;
        /** 6.個の侵害 */
        violationOfPrivacy: string;
        /** 7.その他ハラスメント */
        otherHarassment: string;
        /** 休暇取得状況 */
        holiday: string;
        /** 時間外、休日労働 */
        overtime: string;
        /** 身体への影響 */
        phisycalEffect: string;
        /** 精神への影響 */
        psychologicalEffect: string;
        /** 相談者以外の被害との比較 */
        discrimination: string;
        /** 他者への相談状況 */
        consultToTheOthers: string;
        /** 職場への影響 */
        effectToTheOthers: string;
        /** 相談者の希望 */
        cunsulterRequest: string;
}


// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/model/consultant.model.ts